module.exports = __webpack_public_path__ + "28b3be3aeecf33f44842d50afb4ec692.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/B_W6.jpg
// module id = 3306
// module chunks = 0